var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { joinPath } from './common.js';
const createEndpointClient = (basePath, instance, { method, path, errors }) => {
    const handler = (params) => __awaiter(void 0, void 0, void 0, function* () {
        return yield instance.exec(method, joinPath(basePath, path), params, errors);
    });
    handler.isError = (error) => {
        // TODO re-enable when RES-1188 is resolved
        // return error instanceof ClientError && errors.includes(error.code)
        return (typeof error === 'object' &&
            error !== null &&
            errors.includes(error === null || error === void 0 ? void 0 : error.code));
    };
    return handler;
};
export default createEndpointClient;
//# sourceMappingURL=createEndpointClient.js.map